import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolderArrowUp24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFolderArrowUp24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.102 5.5H5a.5.5 0 0 0-.5.5v1h7.16l-1.184-1.332a.5.5 0 0 0-.374-.168M3 6v11a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3h-4.333l-2.07-2.329A2 2 0 0 0 10.102 4H5a2 2 0 0 0-2 2m9.993 2.5H18a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 17V8.5zm1.667 5.28a.75.75 0 0 1-1.06 0l-.85-.85v3.27a.75.75 0 1 1-1.5 0v-3.252l-.832.832a.75.75 0 1 1-1.061-1.06l2.121-2.122.53-.53.53.53 2.122 2.121a.75.75 0 0 1 0 1.061"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFolderArrowUp24);
